import { render, staticRenderFns } from "./Watchlist.vue?vue&type=template&id=2557783d&scoped=true"
import script from "./Watchlist.vue?vue&type=script&setup=true&lang=ts"
export * from "./Watchlist.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Watchlist.vue?vue&type=style&index=0&id=2557783d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2557783d",
  null
  
)

export default component.exports